import { EventMykissExploreMarkerClicked } from '../../../interfaces/events';

export const getFishingWaterEventType = (
  layerId: string,
): EventMykissExploreMarkerClicked['properties']['type'] => {
  switch (layerId) {
    case 'forbidden_fishing_waters_layer':
      return 'forbidden_fishing_water';
    case 'empty_fishing_waters_layer':
      return 'empty_fishing_water';
    default:
      return 'fishing_water';
  }
};
